import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconFilter from 'components/icons/iconFilter2';
import { colorGray, colorWhite } from 'styles/layout/colors';

const MobileFiltersButton = ({
  numberOfActiveFilters,
  noMargin = false,
  onClick,
}) => {
  const hasActiveFilters = numberOfActiveFilters > 0;

  return (
    <button
      type="button"
      className={classNames(
        'text-sm font-bold items-center rounded-[3px] flex justify-center p-3 cursor-pointer focus-visible:outline-offset-[5px] border-[1px]',
        {
          'bg-brand border-brand text-white': hasActiveFilters,
          'bg-white border-gray-light6 text-gray': !hasActiveFilters,
          'mr-1.5': !noMargin,
        }
      )}
      onClick={onClick}
    >
      <IconFilter
        className="mr-[6px]"
        color={hasActiveFilters ? colorWhite : colorGray}
      />

      <span
        className={classNames('h-full flex gap-0.5', {
          'text-gray': !hasActiveFilters,
          'text-white': hasActiveFilters,
        })}
      >
        <span>Filters</span>
        {numberOfActiveFilters > 0 && ` (${numberOfActiveFilters})`}
      </span>
    </button>
  );
};

MobileFiltersButton.propTypes = {
  numberOfActiveFilters: PropTypes.number,
  onClick: PropTypes.func,
  noMargin: PropTypes.string,
};

export default MobileFiltersButton;
